/**
 * PageHeader Component
 * Standardized page header with icon, title, subtitle, and actions
 */

import React from 'react';
import { typography } from '../../styles/typography';
import { HelpArticleIcon } from '../HelpCenter/HelpArticleIcon';

export interface PageHeaderProps {
  icon?: React.ReactNode;
  title: string;
  subtitle?: string;
  actions?: React.ReactNode;
  breadcrumbs?: React.ReactNode;
  className?: string;
  /** Opens Help Center to this article when the inline info icon is clicked. */
  helpArticleId?: string;
  helpArticleLabel?: string;
}

export function PageHeader({
  icon,
  title,
  subtitle,
  actions,
  breadcrumbs,
  className = '',
  helpArticleId,
  helpArticleLabel,
}: PageHeaderProps) {
  return (
    <div className={`mb-6 ${className}`}>
      {breadcrumbs && <div className="mb-3">{breadcrumbs}</div>}
      
      <div className="flex items-center justify-between">
        <div className="flex-1">
          <h1 className={`${typography.pageTitle} flex items-center gap-3`}>
            {icon && <span className="text-primary-600 dark:text-primary-400">{icon}</span>}
            <span className="inline-flex items-center gap-2">
              {title}
              {helpArticleId && (
                <HelpArticleIcon
                  articleId={helpArticleId}
                  label={helpArticleLabel ?? `Help: ${title}`}
                />
              )}
            </span>
          </h1>
          {subtitle && <p className={typography.pageSubtitle}>{subtitle}</p>}
        </div>
        
        {actions && <div className="flex items-center gap-2 ml-4">{actions}</div>}
      </div>
    </div>
  );
}

